import "./WhatsChangingSection.scss";
import { Card, Tag, Typography } from "antd";
import React from "react";
import type { WhatsChangingRow } from "./buildWhatsChangingRows";

const { Text } = Typography;

type WhatsChangingSectionProps = {
  rows: WhatsChangingRow[];
};

const getStatusTag = (row: WhatsChangingRow) => {
  if (row.isFooter) return null;

  if (row.status === "changed") {
    return (
      <Tag
        color={row.key === "term-dates" ? "blue" : "gold"}
        className="whats-changing__status-tag"
      >
        Changed
      </Tag>
    );
  }

  return (
    <Tag className="whats-changing__status-tag whats-changing__status-tag--same">
      Same
    </Tag>
  );
};

const getRowClassName = (row: WhatsChangingRow) => {
  if (row.status !== "changed") return "whats-changing__row";

  return row.key === "term-dates"
    ? "whats-changing__row whats-changing__row--changed whats-changing__row--changed-blue"
    : "whats-changing__row whats-changing__row--changed";
};

export const WhatsChangingSection = (props: WhatsChangingSectionProps) => {
  const { rows } = props;
  const bodyRows = rows.filter((row) => !row.isFooter);
  const footerRow = rows.find((row) => row.isFooter);

  return (
    <Card>
    <section className="whats-changing">
      <div className="whats-changing__header">
        <h3 className="whats-changing__title">What&apos;s Changing</h3>
        <p className="whats-changing__subtitle">
          Every line compares the expiring term to the renewal you built. Only highlighted rows changed.
        </p>
      </div>

      <table className="whats-changing__table">
        <thead>
          <tr className="whats-changing__head-row">
            <th className="whats-changing__head-cell">Term Detail</th>
            <th className="whats-changing__head-cell">Expiring Term</th>
            <th className="whats-changing__head-cell">Renewal</th>
          </tr>
        </thead>
        <tbody>
          {bodyRows.map((row) => (
            <tr key={row.key} className={getRowClassName(row)}>
              <td className="whats-changing__cell whats-changing__label">{row.label}</td>
              <td className="whats-changing__cell">{row.expiring}</td>
              <td className="whats-changing__cell">
                <span className="whats-changing__renewal-value">
                  <Text>
                    {row.renewal}
                    {row.renewalSuffix ? <span className="whats-changing__suffix"> {row.renewalSuffix}</span> : null}
                  </Text>
                  {getStatusTag(row)}
                </span>
              </td>
            </tr>
          ))}
          {footerRow ? (
            <tr className="whats-changing__row whats-changing__row--footer">
              <td className="whats-changing__cell whats-changing__label">{footerRow.label}</td>
              <td className="whats-changing__cell">{footerRow.expiring}</td>
              <td className="whats-changing__cell">
                <Text strong>{footerRow.renewal}</Text>
              </td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </section>
    </Card>
  );
};
